// ----------------------------------------------------------------------------
// Section: Bundle Cards
// ----------------------------------------------------------------------------
// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper/modules';
import 'snippets/card/card';
import 'snippets/icon/icon';
import 'snippets/swiper-controls/swiper-control';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_bundle-cards.scss';

// -------------------------------------
// Variables
// -------------------------------------
var BREAKPOINT = 768;
var CAROUSEL_SELECTOR = '.carousel--bundle-cards';
var CAROUSEL_CLASS = 'carousel--bundle-cards';
var CAROUSEL_SECTION_SELECTOR = '.bundle-cards';
var CAROUSEL_SECTION_CLASS = 'bundle-cards';
var CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
var CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
var CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';
var swiperInstances = [];
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
  setupCarousel(element, index);
});
function setupCarousel(element, index) {
  var _element$querySelecto;
  var carousel = element.querySelector(CAROUSEL_SELECTOR);
  if (!carousel) return;
  var uniqueClass = "".concat(CAROUSEL_CLASS, "-").concat(index);
  var paginationClass = "".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index);
  var prevBtnClass = "".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-").concat(index);
  var nextBtnClass = "".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(index);
  var slidesNumber = carousel.querySelectorAll('.swiper-slide');
  if (slidesNumber.length < 5) {
    element.classList.add('static-slides');
    return;
  }
  carousel.classList.add(uniqueClass);
  element.querySelectorAll(CAROUSEL_PREV_BUTTON_SELECTOR).forEach(btn => btn.classList.add(prevBtnClass));
  element.querySelectorAll(CAROUSEL_NEXT_BUTTON_SELECTOR).forEach(btn => btn.classList.add(nextBtnClass));
  (_element$querySelecto = element.querySelector(CAROUSEL_PAGINATION_SELECTOR)) === null || _element$querySelecto === void 0 || _element$querySelecto.classList.add(paginationClass);

  // Guardamos referencia para poder destruir y re-instanciar
  var swiperState = {
    element,
    index,
    swiper: null
  };
  swiperInstances.push(swiperState);

  // Init por primera vez
  handleSwiperState(swiperState);
}
function handleSwiperState(swiperState) {
  var {
    element,
    index
  } = swiperState;
  var classSuffix = ".".concat(CAROUSEL_CLASS, "-").concat(index);
  if (window.innerWidth < BREAKPOINT) {
    if (swiperState.swiper) {
      swiperState.swiper.destroy(true, true);
      swiperState.swiper = null;
    }
    return;
  }
  if (swiperState.swiper) return;
  var swiper = new Swiper(classSuffix, {
    modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
    slidesPerView: 1.2,
    spaceBetween: 0,
    watchOverflow: true,
    keyboard: true,
    observer: true,
    observeParents: true,
    a11y: true,
    breakpoints: {
      768: {
        slidesPerView: 5.2,
        spaceBetween: 8
      }
    },
    pagination: {
      el: ".".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index),
      clickable: true,
      renderBullet: function renderBullet(bulletIndex, className) {
        var isActive = this.activeIndex === bulletIndex ? 'aria-current="true"' : '';
        return "<span type='button' tabindex='0' class='".concat(className, "' ").concat(isActive, "></span>");
      }
    },
    navigation: {
      nextEl: ".".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(index),
      prevEl: ".".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-").concat(index)
    },
    on: {
      init() {
        removeLazyFromVisibleSlides(this);
      },
      slideChange() {
        var bullets = element.querySelectorAll(".".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index, " .swiper-pagination-bullet"));
        bullets.forEach((bullet, bulletIndex) => {
          bullet.setAttribute('aria-current', bulletIndex === swiper.activeIndex ? 'true' : '');
        });
        removeLazyFromVisibleSlides(this);
      }
    }
  });
  swiperState.swiper = swiper;
  var paginationBullets = element.querySelectorAll(".".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index, " .swiper-pagination-bullet"));
  paginationBullets.forEach((bullet, bulletIndex) => {
    bullet.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        swiper.slideTo(bulletIndex);
      }
    });
  });
}
function removeLazyFromVisibleSlides(swiperInstance) {
  swiperInstance.slides.forEach(slide => {
    var rect = slide.getBoundingClientRect();
    var inView = rect.left < window.innerWidth && rect.right > 0;
    if (inView) {
      var img = slide.querySelector('.card__main-image[loading="lazy"]');
      if (img) img.removeAttribute('loading');
    }
  });
}
var resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    swiperInstances.forEach(handleSwiperState);
  }, 200);
});